(function () {
  function closeAccordion(ad) {
    if (!ad || typeof ad.close !== 'function') return;
    var det = ad.querySelector('details');
    if (det && det.open) {
      ad.close();
    }
  }

  function initExclusive(root) {
    var disclosures = root.querySelectorAll('accordion-disclosure');
    if (disclosures.length === 0) return;

    disclosures.forEach(function (ad) {
      var details = ad.querySelector('details');
      if (!details) return;
      details.addEventListener('toggle', function () {
        if (details.open && !(typeof Shopify !== 'undefined' && Shopify.designMode)) {
          disclosures.forEach(function (other) {
            if (other === ad) return;
            var od = other.querySelector('details');
            if (od && od.open) closeAccordion(other);
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-faq-root]').forEach(initExclusive);
  });
})();
